export const TIPO_INTERACAO = {
	EXAME_RESULTADO: 2,
	INFORMACAO_TRATAMENTO: 3,
	OBITO: 5,
};

export const TAB_MENU_ITEMS = [
	{
		id: "dados-principais",
		label: "Dados Principais",
		target: "#dados-principais",
	},
	{
		id: "historico-interacoes",
		label: "Interações",
		target: "#historico-interacoes",
	},
	{
		id: "ultimos-exames",
		label: "Últimos Exames Realizados",
		target: "#ultimos-exames",
	},
	{
		id: "historico-organograma",
		label: "Histórico",
		target: "#historico-organograma",
	},
	{
		id: "jornada-paciente",
		label: "Jornada da Paciente",
		target: "#jornada-paciente",
	},
];
